module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av0415-d4c95fe041b57bf1cbf5afbcc270eafd.jpg";